import { ExpandMoreOutlined } from '@mui/icons-material';
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';

import { AbgTypography } from '@abg/kit-base';

import { FLOW_OF_JOURNEY } from '../../car-info-accordion.constants';

import {
  accordionBoxStyling,
  accordionDetailsStyling,
  accordionSummaryStyling,
  greenTextPoints,
  greyTextPoints,
  iconStyles,
  modifyAccordionDetailsStyling,
  modifyAccordionSummaryStyling,
  pointsHeadingStyling,
  pointsLineItemsStyling,
  redTextPoints,
} from './points-accordion.styling';
import { PointsAccordionSectionProps } from './points-accordion.types';

export default function PointsAccordionSection({
  expanded = false,
  onChange,
  i18nForPoints = [],
  appliedPoints = 2600,
  lineItems = [],
  panelName = 'applied-points',
  flowOfJourney = FLOW_OF_JOURNEY.RESERVATION,
}: Readonly<PointsAccordionSectionProps>) {
  return (
    <MuiAccordion
      sx={pointsHeadingStyling}
      square
      onChange={onChange}
      disableGutters
      elevation={0}
      expanded={expanded}
    >
      <AccordionSummary
        sx={
          flowOfJourney === FLOW_OF_JOURNEY.RESERVATION
            ? accordionSummaryStyling
            : modifyAccordionSummaryStyling
        }
        aria-controls={`${panelName}-content`}
        id={`${panelName}-summary`}
        expandIcon={<ExpandMoreOutlined sx={iconStyles} />}
      >
        <Box sx={accordionBoxStyling}>
          <AbgTypography variant="bodySmallMedium">
            {i18nForPoints[0]}
          </AbgTypography>
          <AbgTypography
            variant="bodySmallMedium"
            sx={
              flowOfJourney === FLOW_OF_JOURNEY.RESERVATION
                ? greenTextPoints
                : redTextPoints
            }
          >
            {appliedPoints.toLocaleString()} {i18nForPoints[1]}
          </AbgTypography>
        </Box>
      </AccordionSummary>
      <AccordionDetails
        sx={
          flowOfJourney === FLOW_OF_JOURNEY.RESERVATION
            ? accordionDetailsStyling
            : modifyAccordionDetailsStyling
        }
      >
        {lineItems &&
          lineItems.map((item) => (
            <Box key={item.code} sx={pointsLineItemsStyling}>
              <AbgTypography variant="bodySmallRegular" sx={greyTextPoints}>
                {item.description}
              </AbgTypography>
              <AbgTypography
                variant="bodySmallRegular"
                sx={
                  flowOfJourney === FLOW_OF_JOURNEY.RESERVATION
                    ? greenTextPoints
                    : redTextPoints
                }
              >
                {item.points?.toLocaleString() ?? ''} {i18nForPoints[1]}
              </AbgTypography>
            </Box>
          ))}
      </AccordionDetails>
    </MuiAccordion>
  );
}
